import React from "react"
import "./assets/styles/style.scss"
import 'swiper/css'
import "particles.js"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { Login } from "./pages/Login";
import { A2f } from "./pages/A2f";
import { Twofactor } from "./pages/Twofactor";
import Services from "./pages/Services";
import { Acceuil } from "./pages/Acceuil";
import { Apropos } from "./pages/Apropos";
import { FAQ } from "./pages/FAQ";
import { Ambassador } from "./pages/Ambassador";
import { Parteners } from "./pages/Partners";
import { PartnersForm } from "./pages/PartnersForm";
import { AmbassadorFormPage } from "./pages/AmbassadorForm";
import { CookiesPolicyPage, GeneralConditionsPage, LexiquePage, MentionLegalesPage, WarningPage, PolitiqueConfPage } from "./pages/Conditions";
import { EmailConfirmation } from "./pages/EmailConfirmation";
import { AppDowload } from "./pages/AppDownload";
import { Disconnect } from "./pages/Disconnect";
import { ForgotPass } from "./pages/ForgotPassword";
import { DroitClient } from "./pages/DroitClient";
import { BandeauBasPage } from './components/pages/acceuil/CookieBanderole';
import {CafeCrypto} from './pages/CafeCrypto';
import { SpeakerForm } from "./pages/SpeakerForm";
import keycloak from "./helpers/keycloak";
import Gleap from 'gleap';

import i18n from './i18n';

// Initialize Gleap with current language
const initializeGleap = () => {
  const currentLanguage = i18n.language || 'en';
  
  // Please make sure to call this method only once!
  Gleap.initialize("azrtJGyiMJVYYhXGIY5Ed8IMzxi4fnUe");
  
  // Set Gleap language based on i18n
  Gleap.setLanguage(currentLanguage);
  
  // Listen to language changes and update Gleap
  i18n.on('languageChanged', (lng) => {
    Gleap.setLanguage(lng);
  });
};

// Initialize Gleap when i18n is ready
if (i18n.isInitialized) {
  initializeGleap();
} else {
  i18n.on('initialized', initializeGleap);
}

function LoginRedirect() {
  React.useEffect(() => {
    window.location.replace("https://dashboard.izichange.com");
  }, []);
  return null;
}

function SignUpRedirect() {
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const referralCode = urlParams.get('ref');
    
    if (referralCode) {
      keycloak.init({ onLoad: 'check-sso' }).then(async () => {
        // Construire l'URL manuellement pour avoir un contrôle total
        const loginUrl = await keycloak.createRegisterUrl();

        if(loginUrl) {

          console.log('Keycloak registration URL:', loginUrl);
          
          // Ajouter le paramètre ref à l'URL de login
          const fullLoginUrl = loginUrl + '&ref=' + referralCode;
  
          // console.log('Redirecting to Keycloak registration URL:', fullLoginUrl);
  
          window.location.href = fullLoginUrl;
        } else {
          window.location.replace("https://dashboard.izichange.com");
        }

      }).catch(err => {
        // console.error('Keycloak initialization failed:', err);
        window.location.replace("https://dashboard.izichange.com");
      });
    } else {
      window.location.replace("https://dashboard.izichange.com");
    }
  }, []);
  
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '20px'
    }}>
      <div style={{
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #008080',
        borderRadius: '50%',
        width: '50px',
        height: '50px',
        animation: 'spin 1s linear infinite'
      }}></div>
      <p style={{ color: '#666', fontSize: '16px' }}>Redirection...</p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

function App() {
  const urlParams = new URLSearchParams(window.location.search.split('?')[1]);
  if(urlParams.get('token'))
    localStorage.setItem('csrf', urlParams.get('token'));

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Acceuil />} />
          <Route path="/sign-up" element={<SignUpRedirect />} />
          <Route path="/disconnect" element={<Disconnect />} />
          <Route path="/services" element={<Services />} />
          <Route path="/login" element={<LoginRedirect />} />
          <Route path="/reset" element={<ForgotPass />} />
          <Route path="/a2f" element={<A2f />} />
          <Route path="/check_a2f" element={<Twofactor />} /> 
          <Route path="/a-propos" element={<Apropos />} />
          <Route path="/vos-droits" element={<DroitClient />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/new-partner" element={<PartnersForm />} />
          <Route path="/ambassadors" element={<Ambassador />} />
          <Route path="/partners" element={<Parteners />} />
          <Route path="/new-ambassador" element={<AmbassadorFormPage />} />
          <Route path="/general-conditions" element={<GeneralConditionsPage />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfPage />} />
          <Route path="/lexical" element={<LexiquePage />} />
          <Route path="/cookies" element={<CookiesPolicyPage />} />
          <Route path="/legal-mentions" element={<MentionLegalesPage />} />
          <Route path="/warning" element={<WarningPage />} />
          <Route path="/email-confirmation" element={<EmailConfirmation />} />
          <Route path="/download_app" element={<AppDowload />} />
          <Route path="/cafe_crypto" element={<CafeCrypto />} />
          <Route path="/new-speaker" element={<SpeakerForm />} />
          <Route path="*" element={<Login />} />

        </Routes>
      </BrowserRouter> 
      <BandeauBasPage /> 
    </div>

  );
}

export default App;
